<template>
	<div class='main-mybody' style="padding-top: 1.5rem;" id='handmehome'>
		<a-row>
			<a-col :span='12'>
				<div style="width: 90%;">
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<div class='look_g'><div></div>外出信息</div>
						<a-row>
							<a-col :span='24'>
								<!-- <a-col :span='8' class='titName' v-html='"員工姓名&nbsp;&nbsp;:"'></a-col> -->
								<a-col :span='8' class='titName' v-html='"員工姓名"'></a-col>
								<a-col :span='16' class='comname'>{{formview.realname}}
									<img v-if='formview.sex == 1' :src="require('@/image/lea/man.png')" alt="">
									<img v-if='formview.sex == 2' :src="require('@/image/lea/woman.png')" alt="">
								</a-col>
							</a-col>
							<a-col :span='24'>
								<!-- <a-col :span='8' class='titName' v-html='"申請日期&nbsp;&nbsp;:"'></a-col> -->
								<a-col :span='8' class='titName' v-html='"申請日期"'></a-col>
								<a-col :span='16' class='comname'>{{formview.createtime}}</a-col>
							</a-col>
							<a-col :span='24'>
							<!-- 	<a-col :span='8' class='titName'
									v-html='"部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;門&nbsp;&nbsp;:"'> -->
									<a-col :span='8' class='titName'
										v-html='"部門"'>
								</a-col>
								<a-col :span='16' class='comname'>{{formview.department}}</a-col>
							</a-col>
							<a-col :span='24'>
								<!-- <a-col :span='8' class='titName '
									v-html='"職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位&nbsp;&nbsp;:"'>
								</a-col> -->
								<a-col :span='8' class='titName '
									v-html='"職位"'>
								</a-col>
								<a-col :span='16' class='comname'>{{formview.job}}</a-col>
							</a-col>
							<a-col :span='24'>
								<a-col :span='8' class='titName ' v-html='"外出時間"'>
								</a-col>
								<a-col :span='16' class='comname'>{{formview.gooutdate}}</a-col>
							</a-col>
							<a-col :span='24'>
								<a-col :span='8' class='titName ' v-html='"外出地點"'></a-col>
								<a-col :span='16' class='comname padleft'>{{formview.address}}</a-col>
							</a-col>
							<a-col :span='24'>
								<a-col :span='8' class='titName ' v-html='"外出事由"'></a-col>
								<a-col :span='16' class='comname padleft'>{{formview.cause}}</a-col>
							</a-col>
						</a-row>
						<div class='main-wid'></div>
						<div class='look_g'><div></div>外出總結</div>
						<!-- <div style="margin: 1rem auto 0.5rem;width: 60%;">
							<div style="width: 100%;height: .5rem;border-bottom: 1px solid rgb(12, 139, 151);"></div>
							<span style='color: rgb(12, 139, 151);font-size: .8rem;position: relative;
    left: 37%;top: -.7rem;display: inline-block;background-color: #fff;padding: 0 .3rem;'>外出總結</span>
						</div> -->
						<a-textarea v-model="form.summarize" class='warp_width' :auto-size="{ minRows: 6, maxRows: 6 }"
							placeholder='請填寫外出總結' style='width: 25.2rem;margin-top: .2rem;'/>
						<div v-if='!form.cardpic'>
							<a-upload name="avatar" class="avatar-uploader" :show-upload-list="false"
								action="https://www.mocky.io/v2/5cc8019d300000980a055e76" :before-upload="beforeUpload"
								@change="handleChange">
								<a-button class='warp_bbtn' size="large">+ 上傳名片</a-button>
							</a-upload>
						</div>
						<a-button v-else class='warp_bbtn' size="large">上傳成功</a-button>
					</a-form-model>
				</div>
			</a-col>
			<a-col :span='12'>
				<rl @child='handff' :stas='0' :waichu='1' :fdate='form.gooutdate' :lihe='"4.1rem"'></rl>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import rl from './rlmate.vue'
	import App from '@/assets/app.js';

	function getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}
	export default {
		props: ['applyid'],
		components: {
			rl
		},
		data() {
			return {
				formview: {
					createtime: "",
					department: "",
					position: "",
					realname: "",
					sex: 0,
					address: '', // 地址
					cause: '', // 事由
				},
				fourthqty: '',
				visible: true,
				ishand: false,
				rules: {},
				form: {
					"token": "",
					"summarize": "",
					"cardpic": "", //base64
					"applyid": '',
					issave: ''
				},
				Arr1: [{
					text: '9:00',
					value: '9:00',

				}, {
					text: '14:00',
					value: '14:00',
				}],
				admintypeArrs: [{
					text: '9:00',
					value: '9:00',

				}, {
					text: '12:00',
					value: '12:00',
				}, {
					text: '14:00',
					value: '14:00',
				}, {
					text: '18:00',
					value: '18:00',
				}],
			}
		},
		mounted() {
			this.handimg()
		},
		methods: {
			handff(val) {
				this.form.gooutdate = ''
				if (val) {
					this.form.gooutdate = val
				}
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.applyid,
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						this.form.summarize = res.data.summarize
						this.form.cardpic = res.data.cardpic

						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleChange(info) {
				getBase64(info.file.originFileObj).then(res => {
					this.form.cardpic = res
					App.oTool.successT();
				})
				// if (info.file.status === 'uploading') {
				//   this.loading = true;
				//   return;
				// }
				// if (info.file.status === 'done') {
				//   // Get this url from response in real world.
				//   getBase64(info.file.originFileObj, imageUrl => {
				//     this.imageUrl = imageUrl;
				//     this.loading = false;
				//   });
				// }
			},

			beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				}
				return isJpgOrPng && isLt2M;
			},
			handcal(ev) {
				// console.log(ev)
			},
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' +
					(time
						.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			backfn(gucode) {
				let str = ''
				this.Arr1.map(ev => {
					if (ev.value == this.form.exchange_code) {
						str = ev[gucode]
					}
				})
				return str
			},
			resetForm(val) {
				this.form.issave = val
				this.form.token = this.$store.state.token;
				this.form.applyid = this.applyid;
				if (!this.form.summarize) {
					App.oTool.warningT('請填寫外出總結');
					return
				}
				// this.$refs[formName].resetFields();
				this.$ajax({
					method: 'post',
					url: this.$api.newOutRecordSummarize,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			nextfn() {

			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#handmehome {
		.warp_bbtn {
			width: 25.2rem;
			height: 2.5rem;
			line-height: 2.5rem;
			font-size: .8rem;
			color: #000;
			margin: 1.2rem 0;
		}

		.ant-divider-horizontal.ant-divider-with-text-center::before,
		.ant-divider-horizontal.ant-divider-with-text-left::before,
		.ant-divider-horizontal.ant-divider-with-text-right::before,
		.ant-divider-horizontal.ant-divider-with-text-center::after,
		.ant-divider-horizontal.ant-divider-with-text-left::after,
		.ant-divider-horizontal.ant-divider-with-text-right::after {
			border-color: #0c8b97;
		}


		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.titName {
			font-size: .8rem !important;
			color: #000;
		}

		.comname {
			font-size: .8rem !important;
		}

		.padleft {
			// padding-left: -.8rem;
			// position: relative;
			// left: -.4rem;
		}

		.ant-modal {
			top: 15vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: .8rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}


		.warp-right {
			text-align: right;
		}

		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: -.3rem;
			}
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
			width: 4rem;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
